// @flow
import { compose } from 'recompose';
import { connect } from 'react-redux';

import HistoryNotifications from './HistoryNotifications';

export default compose(
  connect(
    state => ({}),
    dispatch => ({}),
  ),
)(HistoryNotifications);
